import { InjectionToken } from '@angular/core';

export const NOTIFICATIONS_INITIAL_MESSAGES = new InjectionToken('initialMessages');
export const NOTIFICATIONS_INITIAL_OPTIONS = new InjectionToken('initialOptions');
